// extracted by mini-css-extract-plugin
module.exports = {"loadingField":"NextButton_loadingField__15OZn","NextButton":"NextButton_NextButton__2zCuY"};